import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Row, Form } from "react-bootstrap";
import DateRange from "../../common/DateRange";
import { MemberRole } from "../types/MemberRole";
import { AvailableRole } from "../types/AvailableRole";
import { isNew } from "./MemberListItem";
import LoadingButton from "../../common/LoadingButton";

const MemberRoleItem = ({
  role,
  roles,
  addRole,
  saving,
  save,
  removeRole,
  isLast,
  enabled = false,
  memberStart,
  memberEnd,
}: {
  role?: MemberRole;
  roles: AvailableRole[];
  addRole: Function;
  saving: boolean;
  save: Function;
  removeRole: Function;
  isLast: boolean;
  enabled?: boolean;
  memberStart: string;
  memberEnd: string;
}) => {
  const [changed, setChanged] = useState<MemberRole>();
  const pending = () =>
    (changed &&
      (changed.Role !== role?.Role ||
        changed.RoleEndDate !== role?.RoleEndDate ||
        changed.RoleStartDate !== role?.RoleStartDate)) ||
    !changed?.GroupMemberRoleId;
  const cancel = () => {
    if (!isNew(role) && role) {
      setChanged({ ...role });
    } else {
      removeRole();
    }
  };
  useEffect(() => {
    if (!role) return;
    setChanged({ ...role });
  }, [role]);
  return (
    <Row className="mb-3">
      <Form.Group className="col-6">
        <Form.Label>Select a Role</Form.Label>
        <Form.Select title="Select a Role" name="role-selector"
          id="volunteer-role-list"
          disabled={!enabled || !isNew(role)}
          value={changed?.Role || ""}
          onChange={(e) => setChanged({ ...changed, Role: e.target.value })}
        >
          <option value="" disabled>
            Select a Role
          </option>
          {roles.map((role: AvailableRole, index: number) => (
            <option key={index} value={role.RoleDescription}>
              {role.RoleDescription}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      <DateRange
        disabled={!enabled}
        disabledEnd={isNew(role)}
        hiddenEnd={isNew(role)}
        className="col"
        startLabel="Role Start Date"
        minDate={memberStart ? new Date(memberStart) : null}
        maxDate={memberEnd ? new Date(memberEnd) : new Date()}
        startDate={
          changed?.RoleStartDate ? new Date(changed.RoleStartDate) : null
        }
        onStartDateChange={(val: Date) =>
          setChanged({
            ...changed,
            RoleStartDate: val ? val.toUTCString() : "",
            Role: changed?.Role || "",
          })
        }
        endLabel="Role End Date"
        endDate={changed?.RoleEndDate ? new Date(changed.RoleEndDate) : null}
        onEndDateChange={(val: Date) =>
          setChanged({
            ...changed,
            RoleEndDate: val ? val.toUTCString() : "",
            Role: changed?.Role || "",
          })
        }
      />
      <div className="col-1 d-flex align-items-end justify-content-between">
        {(pending() || saving) && (
          <LoadingButton
            loading={saving}
            variant="success"
            className="mr-2"
            disabled={!enabled}
            onClick={() => save(changed)}
          >
           {!saving && <FontAwesomeIcon icon="save" />}
          </LoadingButton>
        )}
        {(pending() || isNew(role)) && (
          <Button
            variant="secondary"
            className="mr-2"
            disabled={!enabled}
            onClick={() => cancel()}
          >
            <FontAwesomeIcon icon="minus" />
          </Button>
        )}
        {isLast && !pending() && !isNew(role) && (
          <Button
            variant="secondary"
            className="mr-2"
            disabled={!enabled}
            onClick={() => addRole()}
          >
            <FontAwesomeIcon icon="plus" />
          </Button>
        )}
      </div>
    </Row>
  );
};

export default MemberRoleItem;
